import { Document } from "@/schema/Document";
import { Company } from "@/schema/Company";
import CompanyCard from "@/src/_components/CompanyCard";
import DocumentTable from "@/src/console/(auth)/_components/DocumentTable";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

interface AssessmentInfoProps {
  submittedAt: Date;
  submittedBy: string;
  companyInfo: Company;
  documents: Document[];
}

const AssessmentInfo = ({
  submittedAt,
  submittedBy,
  companyInfo,
  documents,
}: AssessmentInfoProps) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="flex flex-col gap-2">
        <div className="text-2xl font-bold">{t("assessment-information")}</div>
        <div className="flex gap-4 justify-start items-center">
          <span>
            {t("submitted")} {format(submittedAt, t("date-format"))}
          </span>
          <span>
            {t("submitted-by")} {submittedBy}
          </span>
        </div>
      </div>
      <div className="mt-4">
        <CompanyCard company={companyInfo} />
      </div>
      <div className="text-2xl font-bold mt-8">{t("company-documents")}</div>
      <div className="mt-4">
        <DocumentTable data={documents} />
      </div>
    </div>
  );
};

export default AssessmentInfo;
